import React from 'react';
import PropTypes from 'prop-types';

import {
  PERMISSION_TYPES,
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_UPLOAD_ACCESS,
} from '../../../../../constants/contributors';
import ContributorFeatureBlock from './ContributorFeatureBlock';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  entityId: PropTypes.string,
  checkType: PropTypes.oneOf(Object.values(CONTRIBUTOR_PERMISSION_CHECK_TYPE)),
  permissions: PropTypes.arrayOf(PropTypes.string),
  fallbackContent: PropTypes.any,
};

const VideoUploadPermissionBlock = ({
  entityId,
  permissions = [
    CONTRIBUTOR_UPLOAD_ACCESS.REVIEW,
    CONTRIBUTOR_UPLOAD_ACCESS.PUBLISH,
  ],
  checkType = CONTRIBUTOR_PERMISSION_CHECK_TYPE.ANY,
  children,
  ...props
}) => {
  const videoUploadPermissionProps = {
    entityId,
    checkType,
    permissions: permissions.map(permission => ({
      type: PERMISSION_TYPES.UPLOAD_ACCESS,
      permission,
    })),
  };

  return (
    <ContributorFeatureBlock
      {...props}
      contributorPermissionProps={videoUploadPermissionProps}
    >
      {children}
    </ContributorFeatureBlock>
  );
};

VideoUploadPermissionBlock.propTypes = propTypes;

export default VideoUploadPermissionBlock;
